import { render, staticRenderFns } from "./RefsCostGroup.vue?vue&type=template&id=68dbd5b6&scoped=true"
import script from "./RefsCostGroup.vue?vue&type=script&lang=ts"
export * from "./RefsCostGroup.vue?vue&type=script&lang=ts"
import style0 from "./RefsCostGroup.vue?vue&type=style&index=0&id=68dbd5b6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dbd5b6",
  null
  
)

export default component.exports